import {  Grid, makeStyles, Tooltip } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import {  invokeGetService, handleSnackBar } from "../../../store/global/actions";
import { useParams } from 'react-router-dom';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';


const useStyles = makeStyles((theme) => ({
    tableCellPadding: {
        paddingLeft: "16px"
    },
    iconsContainer: {
        width: '100%',
        margin: '0 auto',
        padding: '0.5rem',
        display: 'flex',
        gap: '0.3rem',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'left',

    },
    iconButton: {
        width: '6rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '1rem 1rem 2rem',
        cursor: 'pointer',
        border: 'none',
        background: '#fff',
        '&:focus': {
            outline: 'none',
        },
    },
    noMatch: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '8rem'
    },
    iconCard: {
        width: 'calc((100% - 0.9rem) / 4)',
        aspectRatio: '1/1',
        background: '#e3e3e3',
        padding: '0.8rem',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center'
    },
    icon: {
        height: '100%'
    },
    
    disabledIcon: {
        cursor: 'not-allowed',
    },
    iconImageHolder: {
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f0f0',
        boxSizing: 'border-box',
        transition: 'border 0.2s ease',
        border: '3px solid transparent'
    },
    selectedIcon: {
        border: '3px solid #4caf50'
    },
    clusterletName: {
        fontSize: '14px',
        fontWeight: '600',
        marginTop: '0.5rem',
        color: '#000',
        textAlign: 'center',
        width: '100%',
        maxWidth: '6rem',        // match button width
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    clusterletType: {
        fontSize: '12px',
        color: '#666',
        textAlign: 'center'

    }

}));


export default function TransactionNodes({ setNodesLoading, selectedIcons, setSelectedIcons, existingNodes=[], forView = false }) {
    // console.log("TransactionNodes------------------------", {existingNodes, selectedIcons})


    const classes = useStyles();
    const dispatch = useDispatch();
    const params = useParams();

    const [clusterlets, setClusterlets] = useState([]);
    const [loading, setLoading] = useState(false);
    const delegates = clusterlets.filter(c => c.type === 1);
    const digitalTwins = clusterlets.filter(c => c.type === 2);
    const analytics = clusterlets.filter(c => c.type === 3);


    useEffect(() => {
        setLoading(true)
        setNodesLoading(true);
        dispatch(invokeGetService('getClusterlets', { transactionId: params.transaction }))
            .then((response) => {
                if (response.status) {
                    setClusterlets(response.data)
                }else {
                    dispatch(handleSnackBar({ open: true, message: "Something went wrong.", severity: "error" }));
                }
                setLoading(false);
                setNodesLoading(false);
            })

    }, [])

    useEffect(() => {
        if (!forView) return;
        if (!clusterlets.length) return;
    
        // Prevent re-selecting if already selected
        if (selectedIcons.length > 0) return;
    
        const controllerDelegates = clusterlets.filter(c => c.type === 1 && c.subType == 'controller');
    
        if (controllerDelegates.length > 0) {
            setSelectedIcons(controllerDelegates);
        }
    
    }, [clusterlets, forView]);

    const toggleIconSelection = (icon) => {
        const isController = icon.type === 1 && icon.subType === 'controller';
        const isSelected = selectedIcons.some(item => item._id === icon._id);

        if (forView && isController && isSelected) {
            dispatch(handleSnackBar({ open: true, message: 'Controller is mandatory for this view and cannot be deselected.', severity: 'info' }));
            return; // Exit early so it isn't removed
        }
        setSelectedIcons(prev => {
            const isSelected = prev.some(item => item._id === icon._id);
            if (isSelected) {
                return prev.filter(item => item._id !== icon._id); 
            } else {
                return [...prev, icon]; 
            }
        });
    };   
    

    function getClusterletIconPath(item, { fileUrl = '', iconPath = 'node_icons', defaultIcon = 'clusterlet' } = {}) {
        if (!item) return '';

        let imgSrc = '';

        if (item.iconSource === 'library') {
            imgSrc = `/cached_icons/${item.icon}`;
        } else if (item.iconSource === 'custom' || item.isCustomIcon) {
            imgSrc = `${fileUrl}${item.icon}`;
        } else if (!item.icon && defaultIcon !== undefined) {
            imgSrc = `/${iconPath}/${defaultIcon}.svg`;
        } else {
            imgSrc = `/${iconPath}/${item.icon}.svg`;
        }

        return imgSrc;
    }  

    const renderClusterGroup = ({clusterArray, typeLabel, iconPath, defaultIcon }) => {
        if(clusterArray?.length === 0 ) return ;

        const disableNodesIds = existingNodes?.map(item => item?._id); 

        return clusterArray?.map((clusterlet) => {

            const isDisabled = disableNodesIds?.includes(clusterlet?._id) ? true : false;
            const isSelected = selectedIcons?.some(item => item._id === clusterlet._id) ? true : false;

            return (
                <Tooltip
                    arrow
                    placement="top"
                    title={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span>{clusterlet.name}</span>
                            {clusterlet?.type != undefined && clusterlet?.type == 1 && clusterlet?.attributes != undefined && clusterlet?.attributes?.type != undefined && <span style={{ fontSize: '10px', color: '#ccc', textAlign: 'center' }}>{clusterlet?.attributes?.type}</span>}
                        </div>
                    }
                >
                    <button
                        disabled={isDisabled}
                        key={clusterlet._id}
                        onClick={() => toggleIconSelection(clusterlet)}
                        className={`${classes.iconButton} ${isDisabled ? classes?.disabledIcon : ''}`}
                    >
                        <div className={`${classes.iconImageHolder} ${(isSelected || isDisabled) ? classes.selectedIcon : ''}`} >
                            <img
                                src={getClusterletIconPath(clusterlet, { iconPath, defaultIcon })}
                                alt={clusterlet.name}
                                style={{ width: '60%', height: '60%', objectFit: 'contain' }}
                            />
                        </div>


                        <div className={classes?.clusterletName} id="clusterlet_name"> {clusterlet.name} </div>

                        <div className={classes?.clusterletType} > {typeLabel} </div>
                    </button>
                </Tooltip>
            )
        })
    };



    return (
        <Grid row xs={12}>

            <Grid>
                
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                    <div className={`${classes.iconsContainer} icons-list-container`} id="clusterlet_icons">
                        { loading &&
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <LoaderWithProgress size={18} isContent={true} styleRoot={{ marginTop: '8rem' }} />
                        </div>}

                        {!loading && <>
                        {renderClusterGroup({clusterArray: delegates, typeLabel: 'Delegate', iconPath : 'delegate_icons', defaultIcon : 'ide_delegate_inner_default' })} 
                        {renderClusterGroup({clusterArray: digitalTwins, typeLabel: 'Digital Twin' })}
                        {renderClusterGroup({clusterArray : analytics, typeLabel: 'Clusterlet' })}
                        </>}

                        
                    </div>
                   
                </div>
            </Grid>

        </Grid>
    )
}